var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gradient-background",class:_vm.appClass,attrs:{"id":"app"}},[_c('router-view',{staticClass:"main-view"}),_c('transition',{attrs:{"name":_vm.panelTransitionName,"mode":"out-in"}},[_c('router-view',{key:_vm.$route.name,staticClass:"panel-view",class:_vm.panelTransitionName + '-wrapper',attrs:{"name":"panel"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }